const getters = {
  language: state => state.app.language,
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  functionInfoList: state => state.user.functionInfoList,
  pagePermission: (state) => {
  const pagePermission = state.user.functionInfoList
  const data = {}
  pagePermission.map(item => {
    const regData = (/TMC\/Page\/(\w+(-\w+){0,100})\/(\w+(\/\w+)?)/.exec(item.privilegeMark) || [])
    const name = regData[1]
    const functionName = regData[3]
    if (data[name]) {
      data[name][functionName] = item.featureStatus !== 3
    } else {
      data[name] = {
        [functionName]: item.featureStatus !== 3
      }
    }
  })
  return data
}
}
export default getters
